import React, { useState, useEffect } from "react";
import axios from 'axios';
import './customer.css';
import plus from '../assets/images/plus.png';
import AddCustomer from "./AddCustomer";

const Customer = () => {
  const [customers, setCustomers] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchCriteria, setSearchCriteria] = useState("");
  const [selectedCustomer, setSelectedCustomer] = useState(null); // For edit

  useEffect(() => {
    fetchCustomers();
  }, []);

  const fetchCustomers = async () => {
    try {
      const response = await axios.get('https://backend-n2zq.onrender.com/Customerdetails');
      console.log('Received data:', response.data);
      if (response.data) {
        setCustomers(response.data);
      } else {
        console.error('Invalid data format');
        setCustomers([]);
      }
    } catch (error) {
      console.error('Error fetching customer data:', error);
      setCustomers([]);
    }
  };
  const handleCustomerAddOrUpdate = async (formData) => {
    try {
        if (selectedCustomer) {
            // Update existing customer
            await axios.put(`https://backend-n2zq.onrender.com/Customerdetails/${selectedCustomer._id}`, formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });
        } else {
            // Add new customer
            await axios.post('https://backend-n2zq.onrender.com/Customerdetails', formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });
        }
        fetchCustomers();
        setIsModalOpen(false);
        setSelectedCustomer(null);
    } catch (error) {
        console.error('Error adding/updating customer:', error);
    }
};


  const handleDelete = async (id) => {
    try {
      await axios.delete(`https://backend-n2zq.onrender.com/Customerdetails/${id}`);
      fetchCustomers();
    } catch (error) {
      console.error('Error deleting customer:', error);
    }
  };

  const handleEdit = (customer) => {
    setSelectedCustomer(customer);
    setIsModalOpen(true);
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value.toLowerCase());
  };

  const handleCriteriaChange = (e) => {
    setSearchCriteria(e.target.value);
  };

  const filteredCustomers = Array.isArray(customers)
    ? customers.filter((customer) => {
        let matchesSearchQuery = true;
        let matchesCriteria = true;

        if (searchQuery) {
          const query = searchQuery.toLowerCase();
          matchesSearchQuery =
            (customer.firstname?.toLowerCase() || "").includes(query) ||
            (customer.lastname?.toLowerCase() || "").includes(query) ||
            (customer.email?.toLowerCase() || "").includes(query) ||
            (String(customer.phone)?.toLowerCase() || "").includes(query);
        }

        if (searchCriteria) {
          matchesCriteria = (customer.membership?.toLowerCase() || "") === searchCriteria;
        }

        return matchesSearchQuery && matchesCriteria;
      })
    : [];

  console.log("customers--->", customers);

  return (
    <div className="page-container" style={{ width: "85vw" }}>
      <div className="list-top">
        <div className="class">
          <h3>Customer ({filteredCustomers.length})</h3>
        </div>
        <div className="search">
          <input
            type="text"
            placeholder="Type to Search..."
            value={searchQuery}
            onChange={handleSearchChange}
          />
        
          <select value={searchCriteria} onChange={handleCriteriaChange}>
            <option value="">All</option>
            <option value="member">Member</option>
            <option value="non-member">Non-Member</option>
          </select>
        </div>

        <div className="btn-container">
          <button className="tooltip" onClick={() => setIsModalOpen(true)}>
            <img src={plus} alt="logo" />
            <span className="tooltiptext">ADD CUSTOMER</span>
          </button>
        </div>
      </div>

      <div style={{ overflowY: "auto" }}>
        {filteredCustomers.length > 0 ? (
          <table>
            <thead>
              <tr>
                <th>Image</th>
                <th>Firstname</th>
                <th>Lastname</th>
                <th>Phone</th>
                <th>Email</th>
                <th>Membership</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredCustomers.map((data, index) => (
                <tr key={index}>
                  <td>
                    {data.img ? (
                      <img src={data.img} alt="Customer" style={{ width: "50px", height: "50px", borderRadius: "50%" }} />
                    ) : (
                      "No image"
                    )}
                  </td>
                  <td>{data.firstname}</td>
                  <td>{data.lastname}</td>
                  <td>{data.phone}</td>
                  <td>{data.email}</td>
                  <td>{data.membership}</td>
                  <td> 
                    <button onClick={() => handleEdit(data)}>Edit</button>
                    <button onClick={() => handleDelete(data._id)}>Delete</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p style={{ display: "flex", justifyContent: "center", marginTop: "60px" }}>
            No customer detail available
          </p>
        )}
      </div>

      <div>
        {isModalOpen && (
          <AddCustomer
            onCustomerAdd={handleCustomerAddOrUpdate}
            onClose={() => setIsModalOpen(false)}
            customer={selectedCustomer} // Pass selected customer for editing
          />
        )}
      </div>
    </div>
  );
};

export default Customer;











